exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".feedback-choice-editor .content-container {\n  padding-left: 20px; }\n\n.feedback-choice-editor span {\n  font-size: 13px;\n  color: #606060;\n  padding-left: 5px; }\n", ""]);

// exports
